import React, { useCallback, useRef, useState } from 'react';
import ProjectDetailViewContainer from 'js/components/projects/cards/ProjectDetailViewContainer';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ProjectsList, ProjectsListHandle } from 'new/components/pipelines/ProjectsList/List';
import type { ProjectListProps } from 'new/components/pipelines/ProjectsList/types';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import { BannerDescription } from 'new/elements/BannerDescription';
import { ModalMoveToProject } from 'new/elements/ModalMoveToProject';
import { Stack } from 'new/elements/Stack';
import { useModals } from 'new/hooks/useModals';

const Projects = (props: ProjectListProps) => {
  const { hideHeader } = props;
  const { openModal } = useModals();
  const projectsListRef = useRef<ProjectsListHandle>(null);
  const [projectDetail, setProjectDetail] = useState(null);

  const onClickCreateProject = () => {
    openModal(ModalMoveToProject.modalConfig.name, {
      step: 'new',
      contextView: 'projects',
      onSuccessCreateProject: () => projectsListRef.current?.loadProjectData(),
    });
  };

  const handleClose = useCallback((e: MouseEvent) => {
    if (e) {
      e.stopPropagation();
    }
    setProjectDetail(null);
  }, []);

  return (
    <Stack>
      {hideHeader ? null : (
        <BannerDescription
          title="Projects"
          description="By keeping your resources organized, you can streamline workflows, increase productivity, and promote effective communication and collaboration among team members."
          onClick={onClickCreateProject}
          actionTitle="New Project"
        />
      )}

      <ProjectsList ref={projectsListRef} {...props} setProjectDetail={setProjectDetail} />

      {projectDetail && (
        <ProjectDetailViewContainer
          id={projectDetail.id}
          type={projectDetail.type}
          onClose={handleClose}
        />
      )}
    </Stack>
  );
};

Projects.screenConfig = {
  screenName: 'ProjectsList',
  pageTitle: 'All Projects',
  domain: 'integrate',
  modals: [ModalMoveToProject],
  path: `${ROUTE_REDESIGN}${ROUTE_CONNECT}/projects`,
  exact: true,
};

export default Projects;
